import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { Box } from "@mui/material";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";
import React from "react";

export default function WhiteCard({
  label = "Wallet Value :",
  labelTooltip,
  value = "2345514",
  symbol = "",
  width = "fit-content",
  isLoading = false,
  extra,
  ...props
}) {
  return (
    <Box
      p="16px"
      bgcolor={"#FFFFFF"}
      borderRadius={"4px"}
      color={"#555"}
      width={width}
      height={"100%"}
      position={"relative"}
      minHeight={"80px"}
      {...props}
    >
      <Box mb="10px" fontSize="16px" fontWeight={500} className="startRow">
        <Box className="mgr4">{label}</Box>
        {labelTooltip && <IconTooltip content={labelTooltip} />}
      </Box>
      <Box fontWeight={700} fontSize={"24px"}>
        {isLoading ? (
          <StyledSkeleton
            animation="wave"
            sx={{ height: "20px", width: "60%" }}
          />
        ) : (
          `${symbol}${value?.toLocaleString()}`
        )}
      </Box>
      {extra && extra}
    </Box>
  );
}
